import React from 'react';
import { SharedDebugComponent } from '../../common/SharedDebugComponent';
import type { EntityEntitlementForTargetResponse } from '../../../types/EntityEntitlements';

export interface EntityDetailRawViewsTabProps {
    entity: any;
    entityType: string;
    targetEntitlement: EntityEntitlementForTargetResponse | null;
}

export const EntityDetailRawViewsTab: React.FC<EntityDetailRawViewsTabProps> = ({ entity, entityType, targetEntitlement }) => {
    return (
        <SharedDebugComponent
            entity={entity}
            entityType={entityType}
            targetEntitlement={targetEntitlement}
        />
    );
};

